import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { filterResearchReportSelector } from "../redux/selector";

import { controlInfinitiveScrollSelector } from "components/common/ListInfinitiveScrolling/redux/selector";
import { getListReseachReportApi } from "core/http/service/researchReport";
import { GetListResearchReportParams } from "core/http/service/researchReport/paramsTypes";
import {
  getListResearchReportFailed,
  getListResearchReportStart,
  getListResearchReportSuccess,
} from "../redux/getListResearchReport";

function* getListResearchReport(action) {
  const payload = action.payload;

  const { searchContent } = yield select(filterResearchReportSelector);
  const { offset, limit } = yield select(controlInfinitiveScrollSelector(null));

  const params: GetListResearchReportParams = {
    nodeId: payload.nodeId,
    offset: offset,
    limit: payload.limit ?? limit,
    title: searchContent,
    idNews: payload.idNews,
  };

  try {
    const res = yield call(getListReseachReportApi, params);
    yield put({
      type: getListResearchReportSuccess.type,
      payload: {
        data: res,
      },
    });
  } catch (error: any) {
    yield put({
      type: getListResearchReportFailed.type,
    });
  }
}
function* watchGetListResearchReport() {
  yield takeLatest(getListResearchReportStart.type, getListResearchReport);
}

export default function* getListResearchReportSaga() {
  yield all([watchGetListResearchReport()]);
}
